import React from 'react';
import {
    FormControl,
    Radio,
    RadioGroup,
    FormControlLabel
} from '@mui/material';
import { PRIMARY_COLOR } from 'Config';

const CustomRadioButton = ({ label, displayValueID, isSelected, onChange }) => {
    const handleChange = (
        event
    ) => {
        const newValue =
            event
                .target
                .value;
        onChange(
            newValue
        );
    };

    return (
        <FormControl>
            <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                value={
                    isSelected
                        ? displayValueID
                        : ''
                }
                onChange={
                    handleChange
                }
                name="radio-buttons-group"
            >
                <FormControlLabel
                    value={
                        displayValueID
                    }
                    control={
                        <Radio sx={{

                            '&.Mui-checked': {
                                color: PRIMARY_COLOR,
                            }
                        }} />
                    }
                    label={
                        label
                    }
                />
            </RadioGroup>
        </FormControl>
    );
};
export default CustomRadioButton;
